module.exports = __webpack_public_path__ + "img/app-chplay-1.f3dcf2a7.png";